// extracted by mini-css-extract-plugin
export default {"workbody":"work_workbody__tWYLY","wroktitle":"work_wroktitle__D0LOM","wroklist":"work_wroklist__L18CB","wroklistcolo":"work_wroklistcolo__oKGFc"};